import { createFileRoute } from '@tanstack/react-router';

import { LandingSolid } from '#features/landing/components/LandingSolid';

/**
 * Лендинг с тем же наполнением, но более солидной типографикой. Временный экран для сравнения
 * с `/preview/landing`; прод-лендинг не трогает.
 */
export const Route = createFileRoute('/{-$locale}/_layout/preview/landing-solid')({
  staticData: { rendersOwnFooter: true },
  component: LandingSolid,
  ssr: false,
});
